import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';

import { StateProps } from '@/models/State';

export function StateSelect({
  states,
  selectedState,
  onStateChange,
}: {
  states: StateProps[];
  selectedState: string | null;
  onStateChange: (stateId: string | null) => void;
}) {
  return (
    <FormControl variant='outlined' required fullWidth sx={{ mt: 2 }}>
      <InputLabel id='state-select-label'>State</InputLabel>
      <Select
        labelId='state-select-label'
        label='State'
        value={selectedState || ''}
        onChange={(e: SelectChangeEvent) => onStateChange(e.target.value)}
        MenuProps={{ PaperProps: { sx: { maxHeight: 300 } } }}
      >
        {states?.map((s: StateProps) => (
          <MenuItem key={s.id} value={s.id}>
            {s.abbrev}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
